import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { withRouter, NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import isNumber from 'lodash/isNumber'
import capitalize from 'lodash/capitalize'
import classNames from 'classnames'
import { formatDate, formatNumber } from '@atheneum/api/dist/lib'
import CheckIcon from '@components/Icon/Check'
import DashIcon from '@components/Icon/Dash'
import { StatusLabel } from '@components/StatusLabel'

class ResultsTable extends Component {
  static propTypes = {
    entries: PropTypes.object,
    sidebarStore: PropTypes.object
  }

  renderIcon (field) {
    if (field == null) {
      return '-'
    }

    return field ? (
      <CheckIcon className='green-icon' />
    ) : (
      <DashIcon className='red-icon' />
    )
  }

  renderInvoiced ({ invoiced, type }) {
    if (isNumber(invoiced) && type !== 'fee') {
      return formatNumber(invoiced)
    }

    return this.renderIcon(invoiced)
  }

  renderAdjustment ({ adjustment }) {
    if (isNumber(adjustment)) {
      return formatNumber(adjustment)
    }

    return '-'
  }

  renderProjectStatus ({ projectStatus }) {
    if (projectStatus) {
      return (
        <StatusLabel statusId={projectStatus} statusesType='projectStatuses' />
      )
    }

    return '-'
  }

  renderNumber (number) {
    if (isNumber(number)) {
      return formatNumber(number)
    }

    return '-'
  }

  renderEntry ({ type, id, ...entry }) {
    const entryText = `${capitalize(type)} - ${id}`
    let path

    if (type === 'fee') {
      path = `/project/${entry.projectId}/fee/${id}`
    }

    if (type === 'invoice') {
      path = entry.contractId
        ? `/contract/${entry.contractId}/invoice/${id}`
        : `/project/${entry.projectId}/invoice/${id}`
    }

    if (path) {
      return (
        <NavLink
          onClick={e => {
            e.stopPropagation()
          }}
          to={path}
        >
          {entryText}
        </NavLink>
      )
    }

    return <span>{entryText}</span>
  }

  handleAccountClick (accountId) {
    if (accountId) {
      this.props.sidebarStore.openSidebar({
        id: accountId,
        template: 'client-account'
      })
    }
  }

  handleProjectClick (projectId) {
    if (projectId) {
      this.props.sidebarStore.openSidebar({
        id: projectId,
        template: 'project'
      })
    }
  }

  handleContractClick (contractId) {
    if (contractId) {
      this.props.sidebarStore.openSidebar({
        id: contractId,
        template: 'contract'
      })
    }
  }

  renderEntries = () => {
    const { entries } = this.props
    const entryRows = entries.map(entry => {
      const accountClass = classNames({
        'row--link': entry.accountId
      })

      const projectClass = classNames({
        'row--link': entry.projectId
      })

      const contractClass = classNames({
        'row--link': entry.contractId
      })

      return (
        <tr key={entry.type + entry.id} className={''}>
          <td>{this.renderEntry(entry)}</td>
          <td>
            <span
              className={accountClass}
              onClick={() => this.handleAccountClick(entry.accountId)}
            >
              {entry.account || '-'}
            </span>
          </td>
          <td>
            <span
              className={projectClass}
              onClick={() => this.handleProjectClick(entry.projectId)}
            >
              {entry.projectName || '-'}
            </span>
          </td>
          <td>
            <span className='text-wrapper'>{entry.projectCode || '-'}</span>
          </td>
          <td>
            <span className='text-wrapper'>
              {this.renderProjectStatus(entry)}
            </span>
          </td>
          <td>
            <span
              className={contractClass}
              onClick={() => this.handleContractClick(entry.contractId)}
            >
              {entry.contractCode || '-'}
            </span>
          </td>
          <td>
            <span className='text-wrapper'>
              {formatDate(entry.deliveryDate)}
            </span>
          </td>
          <td>
            <span className='text-wrapper'>
              {formatDate(entry.documentDate)}
            </span>
          </td>
          <td>
            <span className='text-wrapper right-align'>
              {this.renderNumber(entry.fee)}
            </span>
          </td>
          <td>
            <span className='text-wrapper right-align'>
              {this.renderInvoiced(entry)}
            </span>
          </td>
          <td>
            <span className='text-wrapper right-align'>
              {this.renderIcon(entry.allocated)}
            </span>
          </td>
          <td>
            <span className='text-wrapper right-align'>
              {this.renderNumber(entry.unallocated)}
            </span>
          </td>
          <td>
            <span className='text-wrapper right-align'>
              {this.renderNumber(entry.adjustment)}
            </span>
          </td>
          <td>
            <span className='text-wrapper right-align'>
              {this.renderNumber(entry.financialRevenue)}
            </span>
          </td>
        </tr>
      )
    })

    return <tbody>{entryRows}</tbody>
  }

  render () {
    return (
      <table className='table-wrapper'>
        <thead>
          <tr>
            <th>Entry</th>
            <th>Account</th>
            <th>Project name</th>
            <th>Project code</th>
            <th>Project status</th>
            <th>Contract code</th>
            <th>Delivery date</th>
            <th>Document date</th>
            <th className='right-align'>Fee</th>
            <th className='right-align'>Invoiced</th>
            <th className='right-align'>Allocated</th>
            <th className='right-align'>Unallocated</th>
            <th className='right-align'>Adjustment</th>
            <th className='right-align'>Financial revenue</th>
          </tr>
        </thead>
        {this.renderEntries()}
      </table>
    )
  }
}

export default withRouter(
  inject('staticData', 'sidebarStore')(observer(ResultsTable))
)
